import AuthorizationRequests from "./AdminSettings/AuthorizationRequests";
import Dashbaord from "./Dashboard";
import Companies from "./AdminSettings/Companies";
import FolderTemplate from "./AdminSettings/FolderTemplate";
import SiteInformation from "./AdminSettings/SiteInformation";
import Login from "./Login";
import Projects from "./AdminSettings/Projects";
import AdminSettings from "./AdminSettings";
import RolesandPermission from "./AdminSettings/RolesandPermission";
import Users from "./AdminSettings/Users";
import ChangePassword from "./AdminSettings/ChangePassword";
import DeleteComponent from "./AdminSettings/DeleteComponent";
import ProjectHome from "./ProjectHome";
import ProjectGeneralInformartion from "./ProjectHome/ProjectGeneralInformartion";
import Holidays from "./AdminSettings/Holidays";
import DownloadCart from "./DownLoadCart";
import AdvancedSearch from "./ProjectHome/AdvancedSearch";
import SystemPrompts from "./AdminSettings/SystemPrompts";

const Views = {
  AuthorizationRequests,
  Dashbaord,
  Companies,
  FolderTemplate,
  SiteInformation,
  Login,
  Projects,
  AdminSettings,
  RolesandPermission,
  Users,
  ChangePassword,
  DeleteComponent,
  ProjectGeneralInformartion,
  ProjectHome,
  Holidays,
  DownloadCart,
  AdvancedSearch,
  SystemPrompts,
};

export default Views;
